import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { inject, observer } from 'mobx-react';
import ObjednavkaStore from '../stores/ObjednavkaStore';
import KlientStore from '../stores/KlientStore';
import {
    Drawer,
    Grid,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Paper,
    TextField,
    Button,
    MenuItem,
    TableHead, TableRow, TableCell, TableBody, Table, LinearProgress
} from '@material-ui/core';
import { observable, action, computed } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import FakturacniSubjekt from '../models/FakturacniSubjekt';
import FakturaceStore from '../stores/FakturaceStore';
import Objednavka from '../models/Objednavka';
import TurnusStore from '../stores/TurnusStore';
import Turnus from '../models/Turnus';
import Klient from '../models/Klient';
import PreparePaymentDetailsResponse from 'src/services/response/PreparePaymentDetailsResponse';
import FakturaceNahled from "../models/FakturaceNahled";

export interface IOrderFakturaceProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    objednavkaStore?: ObjednavkaStore;
    fakturaceStore?: FakturaceStore;
    turnusStore?: TurnusStore;
    objednavkaId: number;
    fromNewOrder: boolean;
}

@inject('klientStore')
@inject('fakturaceStore')
@inject('turnusStore')
@inject('objednavkaStore')
@observer
class OrderFakturace extends React.Component<IOrderFakturaceProps>{

    constructor(props: Readonly<IOrderFakturaceProps>) {
        super(props);
        console.log("LOAD: OrderFakturace/" + props.objednavkaId);

        const turnusy: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(this.props.objednavkaId);
        const clients: Set<number> = new Set();
        turnusy.forEach(turnus => {
            clients.add(turnus.idKlient);
        });
        const subjectIDs: Set<number> = new Set();
        const subjects: FakturacniSubjekt[] = [];
        clients.forEach((cl) => {
            this.props.fakturaceStore.getSubjektyByKlientID(cl).forEach(subj => {
                if(!subjectIDs.has(subj.idSubjekt)) {
                    subjects.push(subj);
                    subjectIDs.add(subj.idSubjekt);
                }
            });
        });

        if(subjects.length > 0) {
            this.finalSubjekt = subjects[0].idSubjekt;
        }

        this.subjekty = subjects;

        this.props.fakturaceStore.getInvoicePreview(this.props.objednavkaId)
            .then(preview => {
                this.nahled = preview;
            })
        this.props.objednavkaStore.preparePaymentDetails(this.props.objednavkaId)
            .then((resp: PreparePaymentDetailsResponse) => {
                this.emailText = resp.emailText;
            })
    }

    @observable private isDrawerOpened: boolean = false;
    @observable private isProgressBarOpened: boolean = false;
    @observable private subjekty: FakturacniSubjekt[] = [];
    @observable private nahled: FakturaceNahled = null;
    @observable private emailText: string = null;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    public doNext = event => {
        if(this.finalSubjekt === 0) {
            alert('Vyberte subjekt');
            return;
        }

        this.isProgressBarOpened = true;

        this.props.objednavkaStore.preparePaymentDetails(this.props.objednavkaId)
            .then((resp: PreparePaymentDetailsResponse) => {
                this.props.fakturaceStore.createInvoice(this.props.objednavkaId, this.finalSubjekt, resp.totalPrice)
                    .then(faktura => {
                        this.props.history.push(`/paymentDetails/${this.props.objednavkaId}`);
                    }, fail => {
                        this.isProgressBarOpened = false;
                    });
            });
    }

    public resetOrder = event => {
        console.log("OrderFakturace: reset order");
        this.isProgressBarOpened = true;
        this.props.objednavkaStore.deleteOrder(this.props.objednavkaId)
            .then(succ => {
                this.props.objednavkaStore.removeObjednavkaFromLocalStore(this.props.objednavkaId);
                this.props.turnusStore.removeLocalTurnusesByObjednavkaID(this.props.objednavkaId);
                this.props.history.push(`/neworder`);
            }, fail => {
                this.isProgressBarOpened = false;
            });
    }

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    // Props

    @observable public finalSubjekt: number = 0;

    public render() {
        return (
            <div>
            <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                <NavigationDrawerItems />
            </Drawer>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    {this.isProgressBarOpened ? <LinearProgress variant="query" color="secondary" /> : ""}
                    <AppBar position="static" >
                        <Toolbar>
                            <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                Fakturace objednávky {this.props.objednavkaId}
                            </Typography>
                            {this.props.fromNewOrder && this.props.objednavkaStore.orderTemplate !== undefined ?
                                <Button onClick={this.resetOrder} color="secondary">
                                    Reset objednávky
                                </Button> : ""}
                            <Button onClick={this.doNext} color="inherit">
                                Další
                            </Button>
                        </Toolbar>
                    </AppBar>
                </Grid>
                <Grid item xs={12} style={{ margin: 8 }}>
                    <Paper style={{ padding: 8 }}>
                        <Grid item xs={6} style={{ margin: 'auto', alignItems: 'center' }} container>
                                <span style={{ marginRight: 20, flexBasis: 250 }}>Fakturační subjekt:</span>
                                <TextField label="Subjekt" id="new-order-subjekt" select onChange={this.handleChange('finalSubjekt')} 
                                    value={this.finalSubjekt}>
                                        <MenuItem value={0}>Vyberte subjekt</MenuItem>
                                        {this.subjekty.map(sub => (
                                            <MenuItem value={sub.idSubjekt}>{sub.name}</MenuItem>
                                        ))}
                                </TextField>
                        </Grid>
                        {this.nahled ?
                        <Grid item xs={6} style={{ margin: 'auto', alignItems: 'center', height: 40 }} container>
                            <span style={{ marginRight: 20, flexBasis: 250 }}>Celková cena:</span>
                            <span>{this.nahled.totalPrice} Kč</span>
                        </Grid>:""}
                        {this.nahled ?
                            <Grid item xs={6} style={{ margin: 'auto' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Položka faktury</TableCell>
                                            <TableCell>Cena</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            this.nahled.items.map(polozka => (
                                                <TableRow hover>
                                                    <TableCell>{polozka.name}</TableCell>
                                                    <TableCell>{polozka.price}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                        {/*<TableRow hover>*/}
                                        {/*    <TableCell><TextField /></TableCell>*/}
                                        {/*    <TableCell><TextField /></TableCell>*/}
                                        {/*</TableRow>*/}
                                    </TableBody>
                                </Table>
                            </Grid>
                        : ""}
                        {this.emailText ?
                            <Grid item xs={8} style={{ margin: 'auto', paddingBottom: 16 }}>
                                <Grid container item xs={12}>
                                    <Grid item xs={12} style={{margin: 8, paddingTop: 24}}>
                                        <TextField label="Náhled emailu" multiline value={this.emailText}
                                                   fullWidth disabled={true}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        : ""}
                    </Paper>
                </Grid>
                </Grid>
            </div>
        )
    }

}

export default withRouter(OrderFakturace);


// WEBPACK FOOTER //
// ./src/components/OrderFakturace.tsx